import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {IconServer} from "@tabler/icons-react";
import {useAuth} from "../../Context/AuthContext";
import {useEntra} from "../../Services/entraServices";
import React, {useEffect, useState} from "react";


export function NavBarProfile() {
    const navigate = useNavigate();
    const location = useLocation();

    const { account } = useAuth();
    const { getUserPhoto, getUserProfile } = useEntra();
    const [ photoUrl, setPhotoUrl ] = useState(null);

    const [ userProfile, setUserProfile ] = useState(null);

    useEffect(() => {

        getUserPhoto().then((imageUrl) => {
            if (imageUrl) {
                setPhotoUrl(imageUrl);
            }
        });

        getUserProfile().then((profile) => {
            setUserProfile(profile);
        })

    }, []);



    const handleClick = (path) => {
        navigate(`/${path}`);
    };

    return(
        <>
            <div className="nav-item dropdown">
                <a href="#" className="nav-link d-flex lh-1 p-0 px-2" data-bs-toggle="dropdown" aria-label="Open user menu">

                    {photoUrl ? (
                        <span className="avatar avatar-sm custom-avatar" style={{backgroundImage: `url(${photoUrl})`}}> </span>
                    ) : (
                        <>
                            {account.name &&
                                <span className={`avatar custom-avatar-noimage custom-avatar ${location.pathname === "/settings" ? "active" : ""}`}
                                   data-bs-toggle="tooltip"
                                   data-bs-placement="right" title={account.name} role="button"
                                   aria-expanded="true">
                                    {account.name.split(' ').length > 2
                                        ? `${account.name.split(' ')[0].charAt(0).toUpperCase()}${account.name.split(' ').slice(-1)[0].charAt(0).toUpperCase()}`
                                        : account.name.split(' ').map(part => part.charAt(0).toUpperCase()).join('')}
                                </span>
                            }
                        </>
                    )}

                    <div className="d-none d-xl-block ps-2">
                        <div className="text-white">{account.name}</div>
                        <div className="mt-1 small text-white-50"></div>
                    </div>
                </a>
                <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow" data-bs-theme="light">
                    <a href="#" className="dropdown-item">Status</a>
                    <a href="./profile.html" className="dropdown-item">Profile</a>
                    <a href="#" className="dropdown-item">Feedback</a>
                    <div className="dropdown-divider"></div>
                    <a href="./settings.html" className="dropdown-item">Settings</a>
                    <a href="./sign-in.html" className="dropdown-item">Logout</a>
                </div>
            </div>

        </>
    )
}